export default __webpack_public_path__ + "static/media/part_3_con.db0c8382.gif";